import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import Tab from "../common/Tab/Tab";
import TabItemWithIcon from "../common/Tab/TabItemWithIcon";
import { breachServiceActive } from "../../util/CommonBreach";

const BreachesTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const breachSummaryData = useSelector((state: ApplicationState) =>
        state.breachSummaryState ? (state.breachSummaryState.breachSummaryData ? state.breachSummaryState.breachSummaryData : null) : null
    );

    return breachServiceActive(breachService) ? (
        <Tab tabId="breaches-tabs">
            <TabItemWithIcon title="ID Safety Score" link="/breaches" tabNo="1" selectedTab={props.selectedTab} />
            <TabItemWithIcon
                title="My Breach Exposures"
                titleClass="breach-tab-pd-right-1"
                link="/breaches/exposures"
                tabNo="2"
                selectedTab={props.selectedTab}
                getIcon={() => {
                    return breachSummaryData && breachSummaryData.detectedBreachSummary && breachSummaryData.detectedBreachSummary.newDetectedBreachCount ? (
                        <span className="breach-count-exposure-tab">{breachSummaryData.detectedBreachSummary.newDetectedBreachCount}</span>
                    ) : null;
                }}
            />
            <TabItemWithIcon title="Action Plan" link="/breaches/action-plan" tabNo="3" selectedTab={props.selectedTab} />
            <TabItemWithIcon title="Search Breaches" link="/breaches/search-breaches" tabNo="4" selectedTab={props.selectedTab} />
            <TabItemWithIcon title="FAQ" link="/breaches/faq" tabNo="5" selectedTab={props.selectedTab} />
        </Tab>
    ) : null;
};

export default BreachesTab;
